import { log } from '@domgen/shared/utils/log';
import { PostRegistriaRequest } from '../../models/services/api/postRegistria';
import { RegistriaConciergeResponse } from '../../models/services/api/postRegistria';
import { post } from './client';

export const postRegistria = async (
  postRegistriaRequest: PostRegistriaRequest,
): Promise<RegistriaConciergeResponse> => {
  try {
    return await post<RegistriaConciergeResponse>(
      `/post-registration/registria`,
      postRegistriaRequest,
    );
  } catch (err) {
    log.error({ message: 'Fetch error', data: err });
    throw err;
  }
};
